module.exports = __webpack_public_path__ + "img/copy2.a2cdfd21.svg";